import { Box } from '@mui/material'
import TraceCard from './TraceCard'
import { TRACE_SUMMARY_CARDS } from '../../constants/ocConstants'

export default function TraceSummary({ data }) {

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: 2
      }}
    >
      {TRACE_SUMMARY_CARDS.map((card, idx) => {
        const value = data?.[card.valueKey]

        return (
          <TraceCard
            key={card.valueKey}
            label={card.label}
            value={value}
            disabled={!value}
          />
        )
      })}
    </Box>
  )
}
